(() => {
  let attempts = 0;
  const maxAttempts = 24;

  const timer = window.setInterval(() => {
    attempts += 1;
    const root = document.querySelector('#judgeme_product_reviews');
    const average = root?.querySelector('.jdgm-rev-widg__summary-average');

    if (average) {
      const text = average.textContent.trim();
      const match = text.match(/^(\d+)(?:[.,]0+)\s+av\s+5$/i);
      if (match) average.textContent = `${match[1]} av 5`;
      window.clearInterval(timer);
      return;
    }

    if (attempts >= maxAttempts) window.clearInterval(timer);
  }, 250);
})();
